import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { ApiError } from '../services/api.service';

export function handleApiError(
  authService: AuthService,
  router: Router,
  error: unknown
) {
  if (error instanceof ApiError && error.status == 401) {
    authService.logout(router.url);
    router.navigate(['/login']);
  }
  console.warn(error);
}
